// extracted by mini-css-extract-plugin
export default {"tooltip":"Im-z","sharingV2":"Jm-z","sharingIconsV2":"Km-z","links":"Lm-z","link":"Mm-z","facebookV2":"Nm-z","twitterV2":"Om-z","pinterestV2":"Pm-z"};